import React from 'react';
import Layout from '../dashboard/layouts/layout';
import DashboardModules from '../dashboard/content/dashboard-modules';

function Dashboard() {
    return (
        <Layout>
            <DashboardModules />
        </Layout>
    );
}

export default Dashboard;